import { queryOptions, useQuery } from "@tanstack/react-query"
import axios from "axios"
import { CampaignTemplateMetricsResponseDataSchema, DataResponse } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof CampaignTemplateMetricsResponseDataSchema>>

const campaignTemplateMetricsQuery = (campaignId: string) =>
  queryOptions({
    queryKey: ["campaignTemplateMetrics", campaignId],
    queryFn: async () => {
      const { data } = await axios.get<Response>(`/campaigns/${campaignId}/template-metrics`)
      return data.data
    },
  })

export function useCampaignTemplateMetricsQuery(campaignId: string) {
  return useQuery(campaignTemplateMetricsQuery(campaignId))
}
